<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="formdata.client_name"
        @input="formUpdate"
        label="Client Name"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="formdata.business_name"
        label="Business Name"
        @input="formUpdate"
      ></v-text-field>
    </v-col>
    <v-card flat width="100%">
      <v-card-title>
        Address
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="formdata.unit"
              label="Unit no"
              @input="formUpdate"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="data.street"
              label="Street name"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <!-- <select-suburbs v-model="data.suburb"></select-suburbs> -->
            <v-text-field
              v-model="formdata.suburb"
              label="Suburb"
              @input="formUpdate"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-col cols="4">
      <v-text-field
        label="Type"
        value="Standard"
        @input="formUpdate"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="formdata.size"
        label="Size"
        @input="formUpdate"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="formdata.area"
        label="Area"
        @input="formUpdate"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="formdata.category"
        label="Category"
        @input="formUpdate"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="formdata.consultant"
        label="Consultant"
        @input="formUpdate"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <UploadImages
        uploadMsg="Please upload art-work here"
        @changed="uploadImage"
        :max="1"
        maxError="You can upload only 1 art-work."
        clearAll="Delete Image"
      />
    </v-col>
  </v-row>
</template>

<script>
// import SelectSuburbs from '../../../components/SelectSuburbs.vue'
// import SelectCategories from '../../../../components/SelectCategories'
// import moment from 'moment';
import UploadImages from 'vue-upload-drop-images'

export default {
  name: 'ClientForm',
  props: ['data'],
  components: {
    UploadImages
  },
  data() {
    return {
      image64: null,
      formdata: this.data,
      disallowSubmit: true
    }
  },
  // mounted() {
  //   this.getQuotes()
  // },
  methods: {
    uploadImage(files) {
      if (files.length > 0) {
        let reader = new FileReader()
        reader.onload = e => {
          this.image64 = e.target.result
          this.disallowSubmit = false
          this.$emit('onConvert', {
            img: this.image64,
            submit: this.disallowSubmit
          })
        }
        reader.readAsDataURL(files[0])
      }
    },
    formUpdate() {
      this.$emit('onInput', this.formdata)
    }
  }
}
</script>

<style scoped>
img {
  width: 300px;
  height: 150px;
  object-fit: contain;
}
</style>
